import { QueryCache, QueryClient } from "@tanstack/react-query"

import { errorToast } from "./error-toast"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: "always",
            refetchOnReconnect: "always",
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            if (query.meta?.errorToast && query.state.data === undefined) {
                errorToast(error)
            }
        },
    }),
})

export default queryClient
